import { Base } from '@studiometa/js-toolkit';

/**
 * QuantityInput Class
 */
export default class QuantityInput extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuantityInput',
    refs: ['input', 'minus', 'plus'],
  };

  /**
   * onPlusClick
   */
  onPlusClick() {
    this.$refs.input.stepUp();
  }

  /**
   * onMinusClick
   */
  onMinusClick() {
    this.$refs.input.stepDown();
  }
}
